var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-custom-scrollbar",
    {
      staticClass: "workspace-module-container",
      attrs: { id: "workspace-result-materials" }
    },
    [
      _c("div", { attrs: { id: "projects-table-label" } }, [
        _vm._v("Список товаров")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "result-label-project-name" }, [
        _c("span", { staticClass: "text-project" }, [_vm._v("Проект: ")]),
        _vm._v(" "),
        _c("span", { staticClass: "name-project bold-text" }, [
          _vm._v(_vm._s(_vm.projectName))
        ])
      ]),
      _vm._v(" "),
      _c("div", { attrs: { id: "projects-table-container" } }, [
        _c("table", { staticClass: "result-table" }, [
          _c("thead", [
            _c("tr", { staticClass: "head-tr" }, [
              _c("th", { staticClass: "field-number" }, [_vm._v("№")]),
              _vm._v(" "),
              _c("th", [_vm._v("Изображение")]),
              _vm._v(" "),
              _c("th", [_vm._v("Название")]),
              _vm._v(" "),
              _c("th", [_vm._v("Количество")]),
              _vm._v(" "),
              _c("th", [_vm._v("Цена")]),
              _vm._v(" "),
              _c("th", [_vm._v("Итог")]),
              _vm._v(" "),
              _c("th", { staticClass: "field-edit" })
            ])
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.productsCost, function(product, index) {
              return _c("tr", { staticClass: "body-tr row" }, [
                _c("td", [
                  _c("span", { staticClass: "table-data-central" }, [
                    _vm._v(_vm._s(index + 1))
                  ])
                ]),
                _vm._v(" "),
                _c("td", [
                  _c("img", {
                    staticClass: "result-material-img",
                    attrs: { src: _vm.urlForPhoto(product.src) }
                  })
                ]),
                _vm._v(" "),
                _c("td", [
                  _c("span", { staticClass: "table-data" }, [
                    _vm._v(_vm._s(product.name))
                  ])
                ]),
                _vm._v(" "),
                _c("td", [
                  _c("span", { staticClass: "table-data" }, [
                    _vm._v(
                      _vm._s(product.area) +
                        " " +
                        _vm._s(_vm.getDimensionByType(product.type))
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("td", [
                  _c("span", { staticClass: "table-data" }, [
                    _vm._v(
                      _vm._s(
                        product.price
                          .toString()
                          .replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, " ")
                      ) + " ₽/м²"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("td", [
                  _c("span", { staticClass: "table-data" }, [
                    _vm._v(
                      _vm._s(
                        product.cost
                          .toString()
                          .replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, " ")
                      ) + " ₽"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "div",
                    {
                      staticClass: "table-svg-button",
                      on: {
                        click: function($event) {
                          return _vm.deleteRow(product.productUUID)
                        }
                      }
                    },
                    [
                      _c("SVGAdminDeleteRow", {
                        staticClass: "table-svg-delete"
                      })
                    ],
                    1
                  )
                ])
              ])
            }),
            0
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }